import { DEVICE_TYPE, ROUND_CLOSE_TYPE } from '../../constants/configs'
import ImageUploadForm from './RoundCloseDetailForm/ImageUploadForm'

const EmptyLotteryImage = () => {
  return (
    <div>
      <ImageUploadForm name={ROUND_CLOSE_TYPE.EMPTY_LOTTERY} deviceType={DEVICE_TYPE.WEBSITE} />
      <ImageUploadForm name={ROUND_CLOSE_TYPE.EMPTY_LOTTERY} deviceType={DEVICE_TYPE.MOBILE} />
    </div>
  )
}

export default EmptyLotteryImage
